import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue";
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { menuIconMap } from '@/config';
export default {
  name: 'MenuTree',
  props: {
    treeList: {
      type: Array,
      default: () => []
    }
  },

  setup(__props) {
    const props = __props;
    const router = useRouter();

    function clickItem(route) {
      router.push(route, false);
    }

    const formaterTreeData = computed(() => props.treeList.map(item => {
      var _item$childs;

      return _objectSpread(_objectSpread({}, item), {}, {
        hasChilds: ((_item$childs = item.childs) === null || _item$childs === void 0 ? void 0 : _item$childs.length) > 0
      });
    }));
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");

      const _component_MenuTree = _resolveComponent("MenuTree", true);

      const _component_el_sub_menu = _resolveComponent("el-sub-menu");

      const _component_el_menu_item = _resolveComponent("el-menu-item");

      return _openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formaterTreeData), item => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: item.node.resource_id
        }, [item.hasChilds ? (_openBlock(), _createBlock(_component_el_sub_menu, {
          key: 0,
          index: item.node.resource_id
        }, {
          title: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(_unref(menuIconMap)[item.node.resource_name])))]),
            _: 2
          }, 1024), _createElementVNode("span", null, _toDisplayString(item.node.resource_name), 1)]),
          default: _withCtx(() => [_createVNode(_component_MenuTree, {
            treeList: item.childs
          }, null, 8, ["treeList"])]),
          _: 2
        }, 1032, ["index"])) : (_openBlock(), _createBlock(_component_el_menu_item, {
          key: 1,
          index: item.node.name,
          route: {
            name: item.node.name
          },
          onClick: $event => clickItem({
            name: item.node.name
          })
        }, {
          default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.node.resource_name), 1)]),
          _: 2
        }, 1032, ["index", "route", "onClick"]))], 64);
      }), 128);
    };
  }

};